var t=function(t){if(t)return t>=1024?"".concat((t/1024).toFixed(1),"MB"):"".concat(t,"KB")};export{t as default};
